import { privateFetch } from "api/privateFetch";

/**
 * Download Image
 * @param {string} id User ID
 * @returns {Promise<Response[]>} Response
 */
const downloadImage = async (id) => {
  try {
    const { data } = await privateFetch.get(`/users/${id}/avtar/download`, {
      responseType: "blob",
    });
    return data;
  } catch (error) {
    console.error(error);
    throw error?.message || "Failed to download image";
  }
};

export default downloadImage;
